import LandingPageV2 from './LandingPageV2'
function App() {
  return (
    <div>
      <LandingPageV2/>
    </div>
  );
}

export default App;
